module.exports = __webpack_public_path__ + "static/media/marginalia-virtual-reality.5882bdab.png";